import React from 'react';
import CategoriaMenu from './categoria_menu';
import { getItemDatosSesion } from '../../../../funciones_globales/manejosesion';
import './estilo-menu.css';
import { connect } from 'react-redux';

class Menu extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {                    
            opciones_menu: getItemDatosSesion('menu')? JSON.parse(getItemDatosSesion('menu')): []
        }     
        this.getSubItemsMenu = this.getSubItemsMenu.bind(this);        
    }    

    getSubItemsMenu(items_menu, codigo_raiz){
        let subitems_menu = [];

        items_menu.forEach((item) => {
            if (item.CodigoMenuPadre === codigo_raiz){
                subitems_menu.push(item);            
            }
        });

        return subitems_menu;
    }    
   
    render(){        
        return(       
            <div className={(this.props.isVisibleMenu)?'visible nav-side-menu': 'no-visible nav-side-menu'}>
                <div className='menu-list'>                    
                    <ul id="menu-content">                    
                        {this.state.opciones_menu.map((item_menu, i) =>{
                            if (!item_menu.CodigoMenuPadre){
                                const subCategorias = this.getSubItemsMenu(this.state.opciones_menu, item_menu.CodigoMenu);
                                subCategorias.forEach((subCateg) => {
                                    subCateg.ItemsMenu = this.getSubItemsMenu(this.state.opciones_menu, subCateg.CodigoMenu);                                        
                                });                                    
                                return <CategoriaMenu key={i} nombre_categoria={item_menu.NombreMenu} icono_categoria={item_menu.Icono} subCategorias={subCategorias}/>                                
                            }else{
                                return null;
                            }
                        })}                               
                    </ul>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ((state) => {
    return {isVisibleMenu: state.ui.isVisibleMenu}
});

export default connect(mapStateToProps)(Menu);